import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <div className="admin-dashboard">
      <div className="admin-sidebar">
        <h2>관리자 패널</h2>
        <nav className="admin-nav">
          <Link 
            to="/admin" 
            className={isActive('/admin') && location.pathname === '/admin' ? 'active' : ''}
          >
            대시보드
          </Link>
          <Link 
            to="/admin/products" 
            className={isActive('/admin/products') ? 'active' : ''}
          >
            상품 관리
          </Link>
          <Link 
            to="/admin/categories" 
            className={isActive('/admin/categories') ? 'active' : ''}
          >
            카테고리 관리
          </Link>
          <Link 
            to="/admin/orders" 
            className={isActive('/admin/orders') ? 'active' : ''}
          >
            주문 관리
          </Link>
          <Link 
            to="/admin/users" 
            className={isActive('/admin/users') ? 'active' : ''}
          >
            회원 관리
          </Link>
          <Link 
            to="/admin/notices" 
            className={isActive('/admin/notices') ? 'active' : ''}
          >
            공지사항 관리
          </Link>
          <Link 
            to="/admin/featured" 
            className={isActive('/admin/featured') ? 'active' : ''}
          >
            추천/히트/인기 상품
          </Link>
          <Link 
            to="/admin/weekly-best" 
            className={isActive('/admin/weekly-best') ? 'active' : ''}
          >
            Weekly Best 관리
          </Link>
          <Link 
            to="/admin/points-settings" 
            className={isActive('/admin/points-settings') ? 'active' : ''}
          >
            적립금 설정
          </Link>
          <Link 
            to="/admin/banners" 
            className={isActive('/admin/banners') ? 'active' : ''}
          >
            배너 관리
          </Link>
          <Link 
            to="/admin/crawler" 
            className={isActive('/admin/crawler') ? 'active' : ''}
          >
            상품 크롤링
          </Link>
        </nav>
        <Link to="/" className="back-to-shop">
          ← 쇼핑몰로 돌아가기
        </Link>
      </div>
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminDashboard;

